(function () {
  /*
   * Evita che il listener venga installato più volte.
   */
  if (window.__klaviyoGenerateLeadV2Installed) {
    return;
  }

  window.__klaviyoGenerateLeadV2Installed = true;
  window.dataLayer = window.dataLayer || [];

  /*
   * Email digitata più recentemente in un modulo Klaviyo.
   * Rimane soltanto nella memoria della pagina.
   */
  var lastKlaviyoEmail = '';
  var lastEmailTimestamp = 0;

  /*
   * Deduplicazione dei lead generati durante la stessa pagina.
   */
  var generatedLeads = {};

  function normalizeEmail(value) {
    return String(value || '')
      .trim()
      .toLowerCase();
  }

  function isValidEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  }

  function isKlaviyoFormElement(element) {
    if (!element || !element.closest) {
      return false;
    }

    return Boolean(
      element.closest(
        'form.klaviyo-form, form[class*="klaviyo-form"]'
      )
    );
  }

  function saveEmailFromInput(element) {
    if (
      !element ||
      element.tagName !== 'INPUT' ||
      String(element.type).toLowerCase() !== 'email'
    ) {
      return;
    }

    /*
     * Consideriamo esclusivamente campi appartenenti
     * a moduli Klaviyo.
     */
    if (!isKlaviyoFormElement(element)) {
      return;
    }

    var email = normalizeEmail(element.value);

    if (!isValidEmail(email)) {
      return;
    }

    lastKlaviyoEmail = email;
    lastEmailTimestamp = Date.now();

    console.info(
      '[Klaviyo tracking] Email acquisita dal modulo',
      {
        hasEmail: true
      }
    );
  }

  /*
   * Cattura digitazione, incolla e compilazione automatica.
   */
  document.addEventListener(
    'input',
    function (event) {
      saveEmailFromInput(event.target);
    },
    true
  );

  document.addEventListener(
    'change',
    function (event) {
      saveEmailFromInput(event.target);
    },
    true
  );

  /*
   * Controllo aggiuntivo al clic sul pulsante.
   */
  document.addEventListener(
    'click',
    function (event) {
      var button = event.target.closest
        ? event.target.closest('button')
        : null;

      if (!button || !isKlaviyoFormElement(button)) {
        return;
      }

      var form = button.closest(
        'form.klaviyo-form, form[class*="klaviyo-form"]'
      );

      if (!form) {
        return;
      }

      var emailInput = form.querySelector(
        'input[type="email"]'
      );

      if (emailInput) {
        saveEmailFromInput(emailInput);
      }
    },
    true
  );

  function getEmailFromMetadata(metadata) {
    if (!metadata || typeof metadata !== 'object') {
      return '';
    }

    /*
     * Controlla email, $email, Email e altre
     * eventuali variazioni del nome della proprietà.
     */
    var keys = Object.keys(metadata);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];

      var normalizedKey = String(key)
        .replace(/^\$/, '')
        .trim()
        .toLowerCase();

      if (normalizedKey !== 'email') {
        continue;
      }

      var value = metadata[key];

      if (Array.isArray(value)) {
        value = value[0];
      }

      var email = normalizeEmail(value);

      if (isValidEmail(email)) {
        return email;
      }
    }

    return '';
  }

  function marketingConsentAccepted(metadata) {
    if (
      !metadata ||
      !Object.prototype.hasOwnProperty.call(
        metadata,
        'Accepts Marketing'
      )
    ) {
      /*
       * Alcuni moduli potrebbero non avere
       * questa proprietà.
       */
      return true;
    }

    var value = metadata['Accepts Marketing'];

    if (Array.isArray(value)) {
      value = value[0];
    }

    value = String(value || '')
      .trim()
      .toLowerCase();

    return (
      value === 'true' ||
      value === '1' ||
      value === 'yes'
    );
  }

  window.addEventListener(
    'klaviyoForms',
    function (event) {
      var detail =
        event && event.detail
          ? event.detail
          : {};

      var metadata =
        detail.metaData &&
        typeof detail.metaData === 'object'
          ? detail.metaData
          : {};

      /*
       * Salva l'email anche nel caso in cui compaia
       * in un precedente evento stepSubmit.
       */
      var metadataEmail =
        getEmailFromMetadata(metadata);

      if (metadataEmail) {
        lastKlaviyoEmail = metadataEmail;
        lastEmailTimestamp = Date.now();
      }

      /*
       * generate_lead viene creato esclusivamente
       * sulla conversione principale Klaviyo.
       *
       * Non viene creato su stepSubmit per evitare
       * duplicazioni.
       */
      if (detail.type !== 'submit') {
        return;
      }

      if (!marketingConsentAccepted(metadata)) {
        console.warn(
          '[Klaviyo tracking] Submit escluso: consenso marketing non presente'
        );

        return;
      }

      var email =
        metadataEmail ||
        lastKlaviyoEmail;

      /*
       * Non usa email rimaste in memoria troppo a lungo.
       * Limite: 30 minuti.
       */
      var emailIsRecent =
        lastEmailTimestamp &&
        Date.now() - lastEmailTimestamp <
          30 * 60 * 1000;

      if (!email || !emailIsRecent) {
        window.dataLayer.push({
          event: 'klaviyo_lead_missing_email',
          klaviyo_form_id:
            detail.formId || '',
          klaviyo_form_version_id:
            detail.formVersionId || '',
          klaviyo_event_type:
            detail.type || ''
        });

        console.warn(
          '[Klaviyo tracking] Submit ricevuto ma email non disponibile',
          {
            formId: detail.formId || ''
          }
        );

        return;
      }

      var formId =
        detail.formId || 'unknown';

      var duplicateKey =
        formId + '|' + email;

      if (generatedLeads[duplicateKey]) {
        console.info(
          '[Klaviyo tracking] Lead duplicato ignorato',
          {
            formId: formId
          }
        );

        return;
      }

      generatedLeads[duplicateKey] = true;

      var eventId =
        'klaviyo_' +
        formId +
        '_' +
        Date.now() +
        '_' +
        Math.random()
          .toString(36)
          .slice(2, 8);

      window.dataLayer.push({
        event: 'generate_lead_stape',

        event_id: eventId,

        lead_source: 'klaviyo',
        lead_type: 'newsletter_signup',

        form_provider: 'klaviyo',
        form_name:
          metadata.$source ||
          'klaviyo_form',

        klaviyo_form_id: formId,
        klaviyo_form_version_id:
          detail.formVersionId || '',
        klaviyo_company_id:
          detail.companyId || '',
        klaviyo_locale:
          metadata.$locale || '',

        accepts_marketing: true,

        user_data: {
          email: email
        }
      });

      console.info(
        '[Klaviyo tracking] generate_lead_stape inviato',
        {
          formId: formId,
          eventId: eventId,
          hasEmail: true
        }
      );

      /*
       * Pulisce l'email dopo la conversione.
       */
      lastKlaviyoEmail = '';
      lastEmailTimestamp = 0;
    },
    true
  );

  console.info(
    '[Klaviyo tracking] Listener V2 installato'
  );
})();